// src/components/PrivateRoute.js

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Get user state from AuthContext

// This component wraps the pages we want to protect
const PrivateRoute = ({ element: Component }) => {
    const { currentUser } = useAuth();

    // If currentUser exists (user is logged in), render the requested Component.
    // Otherwise, redirect them to the login page.
    return currentUser ? <Component /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;